import React from "react";

import { FormControlProps } from "@material-ui/core/FormControl";

import { FieldRenderProps } from "react-final-form";

import { useQuery } from "@apollo/client";

import { loader } from "graphql.macro";

import PanelSelect from "./panel-select-mui";

import { NodeClasses } from "./NodeClasses";

const GetAllNodes = loader("./graphql/GetAllNodes.graphql");

interface Props extends FieldRenderProps<any, any> {
  label?: string;
  formControlProps?: FormControlProps;
  nodeClasses?: NodeClasses[];
}

function TreeSelectFieldRender(props: Props) {
  const {
    input: { name, value, onChange },
    meta,
    label,
    formControlProps,
    ...rest
  } = props;
  // const showError =
  //   ((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) &&
  //   meta.touched;

  // const [nodes, setNodes] = useState<any>();
  // TODO suspend true when react bug fixed
  const { data, error, loading } = useQuery(GetAllNodes, {
    variables: {
      depth: 1,
    },
  });
  const { data: allData, error: allError, loading: allLoading } = useQuery(
    GetAllNodes,
    {}
  );
  // if (!allError && !allLoading && nodes !== allData.nodes) {
  //   setNodes(allData.nodes);
  // }
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error);
    return <p>Error :(</p>;
  }
  // console.log("alldata nodes: ", allData, allError, allLoading);
  // if (!allData) {
  //   setNodes(data.nodes);
  // }

  return (
    <PanelSelect
      {...rest}
      name={name}
      label={label}
      onChange={onChange}
      // inputProps={restInput}
      value={value}
      nodes={allData && !allError && !allLoading ? allData.nodes : data.nodes}
      supportDefault={true}
    />
  );
}

export default TreeSelectFieldRender;
